<form [formGroup]="formulario">
  <div>
    <div fxLayout="row">
      <div fxFlex fxLayoutAlign="center center">
        <h3 class="ps-title-large ps-confirm-change-settings-title">Você está alterando uma configuração geral</h3>
      </div>
    </div>
    <div class="ps-confirm-change-settings-desc-content" fxLayout="row">
      <div fxFlex fxLayoutAlign="center center">
        <p class="ps-description-14">
          Isso pode afetar todos os portais e consequentemente todos os  <br>
          processos seletivos já editados. Escolha uma das opções abaixo:
        </p>
      </div>
    </div>
    <div class="ps-confirm-change-settings-opts-content" fxLayout="row">
      <div fxFlex>
        <mat-radio-group
            fxLayout="column"
            color="primary"
            formControlName="cascade_change">
          <mat-radio-button
            *ngFor="let item of dialogOptions"
            [value]="item.id">
            {{item.title}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <mat-dialog-actions class="ps-dialog-container-actions">
      <div fxLayout="row">
        <div fxFlex="100">
          <mat-divider></mat-divider>
        </div>
      </div>
      <div fxLayout="row" fxFill style='margin-top: 2px;'>
        <div fxFlex fxLayoutAlign="end center" class="ps-dialog-content-actions">
          <a mat-stroked-button [mat-dialog-close]="false">Cancelar</a>
          <button
            (click)="dateComponent.data.cascade_change = f.cascade_change.value"
            [disabled]="!formulario.valid"
            mat-raised-button
            color="primary"
            [mat-dialog-close]="true">
            Salvar
          </button>
        </div>
      </div>
    </mat-dialog-actions>
  </div>
</form>
